/**
 * Represents the user menu icon
 */
export class DinapsisNavbarUserMenuIcon {
    /**
     * Initizalize an instance of NavbarMenuIcon
     */
    constructor(idUserMenu, openUserMenu, menuUserOpened, userkeycloak) {
        /**
         * Represents the id of the Html Element user menu
         */
        this.idUserMenu = '';
        this.userkeycloak = userkeycloak;
        this.idUserMenu = idUserMenu;
        this.openUserMenu = openUserMenu;
        if (menuUserOpened)
            this.openUserMenu();
    }
    /**
     * Create the custom component
     * @returns HTML code of the component
     */
    Render() {
        const menuElement = document.createElement('div');
        menuElement.innerHTML = this.menuIcon();
        menuElement.addEventListener('click', () => this.toggleIconAndOpenUserMenu());
        return menuElement;
    }
    /**
     * It returns a string that contains a div with an id and class.
     * @returns A string.
     */
    menuIcon() {
        return `<div class="user-menu-closed"><div><p class="user-name">${this.getUserName}</p></div><div id="${this.idUserMenu}" class="menu-user-btn">
        <div class="menu-user-icon"><i class="material-icons account-circle-white"/>
      </div></div>`;
    }
    toggleIconAndOpenUserMenu() {
        var _a;
        // comprobar que ya está abierto, si es así, cerrarlo
        (_a = document.getElementById(this.idUserMenu)) === null || _a === void 0 ? void 0 : _a.classList.toggle('open');
        this.openUserMenu();
    }
    get getUserName() {
        var _a, _b, _c, _d, _e;
        if ((_a = this.userkeycloak) === null || _a === void 0 ? void 0 : _a.tokenParsed) {
            return `${(_c = (_b = this.userkeycloak) === null || _b === void 0 ? void 0 : _b.tokenParsed) === null || _c === void 0 ? void 0 : _c.given_name} ${(_e = (_d = this.userkeycloak) === null || _d === void 0 ? void 0 : _d.tokenParsed) === null || _e === void 0 ? void 0 : _e.family_name}`;
        }
        return 'User Default Default';
    }
}
//# sourceMappingURL=dinapsis-navbar-user-menu-icon.js.map